import { IsDefined, IsInt, IsOptional } from "class-validator";

import { IEditFormTabContainer } from "../../models";

export class FormSchemaDto {
  id: number;

  @IsInt()
  @IsOptional()
  companyId?: number;

  @IsInt()
  entityId: number;

  @IsDefined()
  @IsOptional()
  layout?: IEditFormTabContainer[];
}
